module.exports = __webpack_public_path__ + "static/media/young-marino.510141df.jpeg";